import { Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import Container from 'src/components/atoms/Container';
import Heading from 'src/components/atoms/Heading/Heading';
import Loader from 'src/components/atoms/Loader';
import { Partner } from 'src/domain';
import { useStoreType } from 'src/hooks/useStoreType';

interface Props {
    partners: Partner[] | undefined;
    onPartnerSelected: (partner: Partner) => void;
    isLoading?: boolean;
}

export const SelectPartner: FC<Props> = ({ partners, onPartnerSelected, isLoading = false }) => {
    const storeType = useStoreType();

    return (
        <Wrapper>
            {isLoading && <Loader />}
            {!isLoading && (
                <>
                    <Heading>
                        Please select which{' '}
                        {storeType === 'WHOLESALE' ? 'business trading partner' : 'operational responsible'} you would
                        like to view:
                    </Heading>
                    <Grid
                        direction={'row'}
                        container
                        sx={{
                            gap: 1,
                            justifyContent: 'center',
                        }}
                    >
                        {partners
                            ?.sort((partnerA, partnerB) => partnerA.name?.localeCompare(partnerB.name ?? '') ?? -1)
                            ?.map((partner) => (
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="info"
                                    key={partner?.compositeId}
                                    onClick={() => {
                                        onPartnerSelected(partner);
                                    }}
                                >
                                    {partner.name} ({partner.country})
                                </Button>
                            ))}
                    </Grid>
                </>
            )}
        </Wrapper>
    );
};

const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-width: 50vw;
`;
